import { FieldLabel } from '@monksflow/monks-ui';
import type { PropsWithChildren } from 'react';

interface PersonaFieldLabelProps extends PropsWithChildren {
  required?: boolean;
  htmlFor?: string;
}

/** Standalone label for grid headers, where the control it names is a column of inputs. */
export const PersonaFieldLabel = ({ children, required, htmlFor }: PersonaFieldLabelProps) => (
  <FieldLabel htmlFor={htmlFor}>
    {children}
    {required && <span className="text-destructive"> *</span>}
  </FieldLabel>
);

PersonaFieldLabel.displayName = 'PersonaFieldLabel';
